import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Product Price
      {record ? `: ${record.item.name}` : ''}
    </span>
  );
};
